<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #countryInput
          formControlName="country" 
          [matAutocomplete]="countryAC" 
          [placeholder]="'LABEL_COUNTRY' | translate"
          (focus)="!countryAC.isOpen && getInitialValues('country')" 
          (blur)="checkAutocompleteObject(form, 'country')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_country_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="countryInput.blur(); clearForm($event)"
          *ngIf="countryInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!countryInput.value && !disabled"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_country_dropdown"
          [displayWith]="displayFn" 
          #countryAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); countryInput.blur()"
          (opened)="autocompleteScroll('country','countryACRef','countryACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.country && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_country_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code }} - {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.country" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('country').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('country').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_COUNTRY' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>